module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Grayzel.87099e72.png";